var _defs, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCmmHIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: none;\n      }\n\n      .stH1 {\n        fill: #ff7900;\n      }\n\n      .st2 {\n        font-family: SamsungSharpSans-Bold, 'Samsung Sharp Sans';\n        font-size: 10px;\n        font-weight: 700;\n        letter-spacing: 0em;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "stH1",
    d: "M70.3,44H9.7c-1.6,0-2.9-1.3-2.9-2.9v-11.2h.9c2.6,0,4.8-2.2,4.8-4.8s-2.2-4.8-4.8-4.8h-.9v-11.2c0-1.6,1.3-2.9,2.9-2.9h60.5c1.6,0,2.9,1.3,2.9,2.9v11.2h-.9c-2.6,0-4.8,2.2-4.8,4.8s2.2,4.8,4.8,4.8h.9v11.2c0,1.6-1.3,2.9-2.9,2.9h0ZM8.6,31.7v9.5c0,.6.4,1,1,1h60.5c.6,0,1-.4,1-1v-9.5c-3.2-.4-5.7-3.2-5.7-6.7s2.5-6.1,5.7-6.7v-9.5c0-.6-.4-1-1-1H9.6c-.6,0-1,.4-1,1v9.5c3.2.4,5.7,3.2,5.7,6.7s-2.5,6.1-5.7,6.7h0Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    className: "st2",
    transform: "translate(20.5 28.7)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "stH1",
    x: 0,
    y: 0
  }, "CMM-"), /*#__PURE__*/React.createElement("tspan", {
    className: "st0",
    x: 28,
    y: 0
  }, "M")), /*#__PURE__*/React.createElement("path", {
    className: "stH1",
    d: "M57.1,26.1h-5.2v5.6h-2.5v-13.5h2.5v5.5h5.2v-5.5h2.5v13.5h-2.5v-5.6Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCmmHIcon);
export default __webpack_public_path__ + "static/media/CMM-H-Icon.fee54b4ef7be40e7da670383321bf96d.svg";
export { ForwardRef as ReactComponent };